// Preset themes for profile customization
// Each theme has a background color and accent color
export interface ThemePreset {
  name: string
  background: string
  accent: string
}

export const THEME_PRESETS: ThemePreset[] = [
  { name: 'Default', background: '#ffffff', accent: '#111827' },
  { name: 'Ocean', background: '#ffffff', accent: '#0284c7' },
  { name: 'Forest', background: '#ffffff', accent: '#059669' },
  { name: 'Sunset', background: '#ffffff', accent: '#ea580c' },
  { name: 'Rose', background: '#ffffff', accent: '#e11d48' },
  { name: 'Cream', background: '#fefce8', accent: '#78350f' },
  { name: 'Slate', background: '#f8fafc', accent: '#475569' },
  { name: 'Midnight', background: '#111827', accent: '#f9fafb' },
  { name: 'Charcoal', background: '#1f2937', accent: '#60a5fa' },
  { name: 'Dark Navy', background: '#0f172a', accent: '#38bdf8' },
]

// Legacy preset themes (for backwards compatibility)
export const PRESET_THEMES = [
  { name: 'Indigo Purple', primary: '#4f46e5', secondary: '#9333ea' },
  { name: 'Ocean Blue', primary: '#0284c7', secondary: '#0891b2' },
  { name: 'Forest Green', primary: '#059669', secondary: '#16a34a' },
  { name: 'Sunset Orange', primary: '#ea580c', secondary: '#dc2626' },
  { name: 'Rose Pink', primary: '#e11d48', secondary: '#db2777' },
  { name: 'Midnight', primary: '#1e293b', secondary: '#475569' },
  { name: 'Amber Gold', primary: '#d97706', secondary: '#ca8a04' },
  { name: 'Violet', primary: '#7c3aed', secondary: '#8b5cf6' },
]

export const GOOGLE_FONTS = [
  'Inter',
  'Roboto',
  'Open Sans',
  'Lato',
  'Poppins',
  'Montserrat',
  'Playfair Display',
  'Merriweather',
  'Source Sans Pro',
  'Raleway',
]

export const DEFAULT_THEME = {
  primary: '#4f46e5',
  secondary: '#9333ea',
  font: 'Inter',
  background: '#ffffff',
  accent: '#111827',
}
